var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuestion(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: "icon-question",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    className: "primary"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    d: "M11.278 15.052c-.006-.19-.008-.333-.008-.428 0-.561.079-1.046.238-1.453a3.28 3.28 0 01.564-.929c.19-.228.533-.56 1.028-.996.495-.437.816-.785.964-1.044.148-.26.223-.543.223-.85 0-.555-.217-1.044-.651-1.464-.434-.421-.966-.632-1.596-.632-.609 0-1.117.191-1.524.572-.408.381-.675.977-.802 1.786L8.245 9.44c.132-1.085.525-1.916 1.179-2.493s1.518-.866 2.592-.866c1.138 0 2.046.31 2.723.929.677.62 1.016 1.368 1.016 2.247 0 .508-.119.977-.357 1.405-.238.429-.704.95-1.397 1.564-.466.413-.77.717-.913.913a2.041 2.041 0 00-.318.675c-.069.254-.108.667-.119 1.238h-1.373zm-.088 2.866v-1.627h1.628v1.627H11.19z"
  })));
}
export default SvgIconQuestion;